import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Card from 'src/components/common/Card.redesign';
import Checkbox from 'src/components/controls/forms/Checkbox';
import ContractGenerationListDto from 'src/models/leasing/ContractGenerationListDto';
import MathUtil from 'src/util/MathUtil';

interface IContractProcessingCardProps {
    agreement: ContractGenerationListDto;
    selectedContracts?: Array<number>;
    readonly?: boolean;
    setSelectedContracts?: (contractIds: Array<number>) => void;
}

// TODO: Find a way to consolidate similar functionality with Agreement Card.
const ContractProcessingCard = (props: IContractProcessingCardProps) => {
    const [selected, setSelected] = useState<boolean>(false);

    useEffect(() => {
        if (!!props.setSelectedContracts) {
            let currentSelections = [...props.selectedContracts];
            if (selected === true && currentSelections.indexOf(props.agreement?.agreementId) === -1) {
                currentSelections.push(props.agreement.agreementId);
            } else if (currentSelections.indexOf(props.agreement?.agreementId) > -1) {
                currentSelections.splice(currentSelections.indexOf(props.agreement.agreementId), 1);
            }
            props.setSelectedContracts(currentSelections);
        }
    }, [selected]);

    // Ignore the &nbsp; it's just spacing ._. somehow the easiest way
    const leaseStatus = () => {
        if (props.agreement.isVoid) {
            // Redish
            return <span style={{color: '#c16363'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Void&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>;
        } else if (props.agreement.inHandDate !== null && props.agreement.inHandDate !== undefined) {
            // Greenish
            return <span style={{color: '#63c191'}}>&nbsp;&nbsp;&nbsp;In Hand&nbsp;&nbsp;&nbsp;&nbsp;</span>;
        } else if (props.agreement.isTransfer === true) {
            // Default Blue
            return <span>Transferred</span>;
        } else if (props.agreement.isCommitted === true) {
            // Purpleish
            return <span style={{color: '#6963c1'}}>Committed&nbsp;</span>;
        } else {
            // Tanish
            return <span style={{color: '#c1b363'}}>Rough Draft</span>;
        }
    };

    const rightPanel = () => {
        return (
            <>
                <span className="right-panel" style={{marginRight: '1.7rem', whiteSpace: 'nowrap'}}>
                    <span>{props.agreement?.leaseType} - {leaseStatus()}</span>
                </span>
            </>
        );
    };

    const dataCell = (label: string, data: string | number, isBlank = false, wholeNumber = false) => {
        if (isBlank) {
            return <span style={{ display: 'table-cell', width: '25%' }} />;
        }

        return (
            <span style={{ display: 'table-cell', width: '25%' }}>
                <span
                    style={{
                        width: '50%',
                        background: '#d5e2ee',
                        color: '#777',
                        fontSize: '.9em',
                        fontWeight: 'bold',
                        display: 'inline-block',
                        padding: '.2rem 0 .2rem 1rem',
                    }}
                >
                    {label}
                </span>
                <span style={{ width: '50%', textAlign: 'right', display: 'inline-block', fontSize: '.75em', padding: '.2rem 1rem .2rem 0' }}>
                    {wholeNumber ? data : MathUtil.cleanNumber((data as number))}
                </span>
            </span>
        );
    };

    const footerContent = () => (
        <div style={{ display: 'table', width: '100%', justifyContent: 'space-between', border: '1px solid #ccc' }}>
            {dataCell('Gross', props.agreement?.grossAcres)}
            {dataCell('Net', props.agreement?.netAcres)}
            {dataCell('Tract Count', props.agreement?.tractCount, false, true)}
        </div>
    );

    return (
        <Card
            badge={`${props.agreement?.leaseNumber + (Number(props.agreement?.tractCount) < 1 ? '- P' : '') || 'N/A'}`}
            newContext={true}
            showMenu={true}
            rightBadgePanel={rightPanel()}
        >
            {props.readonly && (
                <>
                    <div className="agreements-card">
                        <div className="agreements-card-row" style={{width: '100%', marginBottom: '1rem'}}>
                            <div style={{width: '60%'}}>
                                <span className="card-label">Owner: </span>
                                <span 
                                    style={props?.agreement?.isVoid ? {textDecoration: 'line-through'} : {}} 
                                    className="data"
                                >
                                    {props?.agreement?.ownerName}
                                </span>
                            </div>
                            <div style={{width: '40%'}}>
                                <span className="card-label">Leased By: </span>
                                {props?.agreement?.leasedBy || 'N/A'}
                            </div>
                        </div>
                    </div>
                    <div>{footerContent()}</div>
                </>
            )}
            {!props.readonly && (
                <>
                    <div className="agreements-card">
                        <div className="agreements-card-row" style={{width: '100%', marginBottom: '1rem'}}>
                            <div style={{ width: '5%' }}>
                                <Checkbox value={selected} onChange={() => setSelected(!selected)} />
                            </div>
                            <div style={{width: '29%'}}>
                                <span className="card-label">Owner: </span>
                                <span 
                                    style={props?.agreement?.isVoid ? {textDecoration: 'line-through'} : {}} 
                                    className="data"
                                >
                                    {props?.agreement?.ownerName}
                                </span>
                            </div>
                            <div style={{width: '20%'}}>
                                <span className="card-label">Leased By: </span>
                                {props?.agreement?.leasedBy || 'N/A'}
                            </div>
                            <div style={{width: '23%'}}>
                                <span className="card-label">Commit Date: </span>
                                {(props.agreement?.committedDate && props.agreement?.isCommitted === true) ? moment(props.agreement?.committedDate).format('MM-DD-YYYY') : 'N/A'}
                            </div>
                            <div style={{width: '23%'}}>
                                <span className="card-label">In Hand Date: </span>
                                {props.agreement?.inHandDate ? moment(props.agreement?.inHandDate).format('MM-DD-YYYY') : 'N/A'}
                            </div>
                        </div>
                    </div>
                    <div>{footerContent()}</div>
                </>
            )}
        </Card>
    );
};

export default ContractProcessingCard;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ProcessingAndMaintenance/ContractProcessingCard.tsx